<template>
    <div>
        <div class="width100 text-center" style="font-size: 1.5rem;padding: 2rem 0">
            商家名称: {{shop.invoiceProvideCompany}}
        </div>
        <div @click="phoneNumber"  class="kefubtn text-center" style="margin-top: 2rem;">
            <div style="font-size: 1.5rem;">
                客服电话
            </div>
            <div style="font-size: 12px">
                服务时间 {{shop.customerServiceTime}}
            </div>
        </div>
        <div  class="testBtn kefubtn text-center" style="margin-top: 4rem;;margin-bottom: 10rem">
            <div style="font-size: 1.5rem;">
                在线客服
            </div>
            <div style="font-size: 12px">
                服务时间 {{shop.customerServiceTime}}
            </div>
        </div>
    </div>
</template>

<script>
    import { baseUrl } from 'common/env'
    import { Search } from 'vant';
    import { areaList } from '@vant/area-data';
    import { postnotoken } from 'api/postnotoken'
    import { get } from 'api/get'

    export default {
        name:'home',
        data() {
            return {
                shop:{
                    name: '',
                    logo: '',
                    invoiceProvideCompany: '',
                    customerServicePhone: '',
                    customerServiceTime: '',
                    onlineServiceTime: '',
                    businessLicense: ''
                }
            };
        },
        created() {
            this.getShopDetail()
        },
        methods: {
            phoneNumber() {
                window.location.href = 'tel://' + this.shop.customerServicePhone
            },
            getShopDetail() {
                let self = this
                get('setting/sysParam/sys_shop_param').then((res) => {
                    console.log(res)
                    if (res.code === self.GLOBAL.SUCCESS) {
                        let resData = JSON.parse(JSON.stringify(res.data))
                        //
                        // self.shop.name = resData.find(i => i.dictLabel == '商城名称').dictValue
                        // self.shop.logo = resData.find(i => i.dictLabel == '商城LOGO').dictValue
                        self.shop.invoiceProvideCompany = resData.find(i => i.dictLabel == '发票提供公司').dictValue
                        self.shop.customerServicePhone = resData.find(i => i.dictLabel == '商城客服电话').dictValue
                        self.shop.customerServiceTime = resData.find(i => i.dictLabel == '商城服务时间').dictValue
                        self.shop.onlineServiceTime = resData.find(i => i.dictLabel == '商城在线服务时间').dictValue
                        self.shop.businessLicense = resData.find(i => i.dictLabel == '营业执照').dictValue

                        console.log(self.shop)
                    } else {
                        self.$dialog.alert({
                            theme: 'round-button',
                            message: res.message,
                            confirmButtonColor: '#f2250f'
                        })
                    }
                })
            },
        }
    };
</script>

<style>

</style>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/view/base/help.vue